import React, { useState, useContext } from 'react'
import _ from 'lodash'
import Button from 'react-bootstrap/Button'
import { FaExclamationTriangle } from 'react-icons/fa'
import Select from 'react-select'

import ProfileCard from './components/profile_card'

import showToastNotification from '../widgets/toastify'
import * as Constants from '../../helpers/constants'
import LoadingWrapper from '../widgets/loading'
import { ApiHelper } from '../../helpers/apihelper'
import AppConfigContext from '../app_layout/app_config_context'
import { SEARCH_TYPE_OPTIONS } from './helpers/constants'
import * as Helpers from '../../helpers/helper'

import '../../static/css/prospect_search.css'

const initialState = {
  profiles: [],
  isLoading: false,
  search_value: '',
  search_type: 'linkedin',
  error: null,
}

const getApiParams = (value, selectedSearchType) => {
  return {
    filters: JSON.stringify({ [selectedSearchType.filter_name]: value }),
  }
}

const validateLinkedinUrl = (url) => {
  if (!url || typeof url !== 'string') return false

  const trimmedUrl = url.trim()

  try {
    const parsed = new URL(trimmedUrl)
    return parsed.hostname.includes('linkedin.com')
  } catch {
    return false
  }
}

const ProspectSearch = () => {
  const [state, setState] = useState(initialState)

  const appConfig = useContext(AppConfigContext)
  const client = appConfig.client
  const clientDisplayName = Constants.CLIENTS[client.toUpperCase()].DISPLAY_NAME
  const selectedSearchType = _.find(SEARCH_TYPE_OPTIONS, { value: state.search_type })

  const loadProfiles = () => {
    const { search_value, search_type } = state

    if (!search_value) {
      setState(prev => ({
        ...prev,
        error: 'Please enter a value to search',
      }))
      return
    }

    let isValid = false
    let errorMessage = ''

    if (search_type === 'linkedin') {
      isValid = validateLinkedinUrl(search_value)
      errorMessage = 'Please enter a valid LinkedIn URL'
    } else if (search_type === 'email_address') {
      isValid = Helpers.validateEmailAddress(search_value)
      errorMessage = 'Please enter a valid email'
    } else if (search_type === 'name') {
      const trimmed = search_value.trim()
      isValid = Helpers.isAlphabet(trimmed)
      errorMessage = 'Please enter a valid name'
    }

    if (!isValid) {
      setState(prev => ({
        ...prev,
        error: errorMessage,
      }))
      return
    }

    setState(prev => ({
      ...prev,
      error: null,
      isLoading: true
    }))

    const requestQueryParams = getApiParams(search_value, selectedSearchType)

    let queryParams = _.pick(requestQueryParams, ApiHelper(client, 'GET_PROSPECT_PERSON').API_QUERY)

    ApiHelper(client, 'GET_PROSPECT_PERSON')
      .API(client, queryParams)
      .then((res) => {
        if (res.status === Constants.CO_API.SUCCESS) {
          setState(prev => ({
            ...prev,
            profiles: res.data.leads,
            isLoading: false,
          }))
        } else {
          setState(prev => ({
            ...prev,
            isLoading: false,
          }))
          showToastNotification({
            message: _.get(res, 'error.message', 'Something went wrong'),
            isSuccess: false,
          })
        }
      })
      .catch((err) => {
        setState(prev => ({
          ...prev,
          error: err.message,
          isLoading: false,
        }))
      })
  }

  const handleSearchTypeChange = (option) => {
    setState((prev) => ({
      ...prev,
      search_value: '',
      search_type: option.value,
      error: null,
      profiles: []
    }))
  }

  const handleSearchInputChange = (e) => {
    setState((prev) => ({
      ...prev,
      search_value: e.target.value,
      profiles: [],
      error: null
    }))
  }

  return (
    <>
      <section className="content-header">
        <h1 className="header">{clientDisplayName} Prospect Search</h1>
      </section>
      <section className="content">
        <div className="page-container container-fluid">
          <div className="page-content d-flex flex-column">
            <div className="prospect-search-filters">
              <Select
                options={SEARCH_TYPE_OPTIONS}
                value={selectedSearchType}
                onChange={handleSearchTypeChange}
                className="prospect-search-select"
                isSearchable={false}
              />
              <input
                id='prospect-search-input'
                type={selectedSearchType.input_type}
                value={state.search_value}
                onChange={handleSearchInputChange}
                placeholder={selectedSearchType.placeholder}
                className="form-control"
                autoComplete="off"
              />
              <Button
                variant="primary"
                onClick={loadProfiles}
                disabled={state.isLoading}
              >
                Search
              </Button>
            </div>
            {state.error && (
              <div className="error-message">
                <FaExclamationTriangle /> {state.error}
              </div>
            )}
            {state.isLoading && (
              <div className="loader-container">
                <LoadingWrapper
                  type="bars"
                  color="#6229e3"
                  height={50}
                  width={50}
                />
              </div>
            )}
            <div className="prospect-search-results">
              {_.isEmpty(state.profiles) ?
                <h1 className="prospect-search-empty-results">
                  No Profiles Found ;(
                </h1>
                :
                _.map(state.profiles, (profile) => (
                  <ProfileCard
                    key={profile.id}
                    profile={profile}
                    client={client}
                  />
                ))
              }
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ProspectSearch


